// const Button = ({ onClick, label }) => (
//   <button className="bracket-button" onClick={onClick}>
//     <svg
//       viewBox="0 0 11 35"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       className="bracket"
//     >
//       <path
//         vectorEffect="non-scaling-stroke"
//         d="M11 1H6.55556L1 5.71429V29.2857L6.55556 34H11"
//       />
//     </svg>
//     <div>{label}</div>
//     <svg
//       className="bracket"
//       viewBox="0 0 11 35"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         vectorEffect="non-scaling-stroke"
//         d="M-4.76837e-07 1H4.44444L10 5.71429V29.2857L4.44444 34H-4.76837e-07"
//       />
//     </svg>
//   </button>
// );

const Button = ({ onClick, label }) => (
  <button className="retro-button" onClick={onClick}>
    {label}
  </button>
);

export default Button;
